// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.85.0-beta.2332982fc',
  revision: '2332982fc',
  branch: 'develop',
  date: 'Fri, 27 Feb 2026 11:42:41 GMT'
};